import { useSearchParams } from 'react-router-dom';
import App from './App';
import Authenticate from './Authenticate';

export function AppWrapper() {
  const [searchParams] = useSearchParams();

  const code = searchParams.get('code');
  const error_description = searchParams.get('error_description');

  if (code || error_description) {
    return <Authenticate />;
  }

  return <App />;
}
